export const reservationInvoicePanel = {
  loadingVerifying: "Verificando…",

  status: {
    draft: "Borrador",
    sent: "Emitida",
    processing: "Procesando",
    pending: "Pendiente",
    error: "Error",
    corrected: "Corregida",
    voided: "Anulada",
  },

  common: {
    cancel: "Cancelar",
    understood: "Entendido",
    optional: "opcional",
    optionalParen: "(opcional)",
    sending: "Enviando…",
    saving: "Guardando…",
    deleting: "Eliminando…",
    emitting: "Emitiendo…",
    creating: "Creando…",
    retrying: "Reintentando…",
  },

  issued: {
    title: "Facturas emitidas",
    rectifOf: "Rectif. de {code}",
    viewPdf: "Ver PDF",
    sendByWhatsapp: "Enviar por WhatsApp",
    correctTitle: "Corregir (rectificativa)",
    voidTitle: "Anular (rectificativa)",
  },

  empty: {
    guestRequested: "El huésped solicitó su factura",
    noInvoice: "Sin factura emitida",
    linkSent: "Link enviado",
    requested: "Solicitada",
    requestedSub: "Revisa sus datos y emite la factura, o envíale el link para que los confirme.",
    sub: "Envía el link al huésped o crea la factura directamente.",
    copyLinkTitle: "Copiar link al portapapeles",
    sendLink: "Enviar link",
    createInvoice: "Crear factura",
    configureHint: "Configura tus datos de facturación para activar esta función.",
  },

  next: {
    title: "Esta reserva ya tiene su factura",
    sub: "¿Hubo un cargo después? Crea otra factura para esta reserva: solo llevará los cargos nuevos (el alojamiento ya facturado no se repite).",
    button: "Crear otra factura para esta reserva",
  },

  card: {
    draftRefTitle: "Referencia interna del borrador. El número fiscal se asigna al emitir.",
  },

  draft: {
    emptyHint: 'Añade al menos un cargo en <b>“Cargos nuevos”</b> para poder emitir esta factura.',
    noteLead: "Borrador — edita los datos o añade cargos arriba; el número y la fecha se asignan al <b>emitir</b>.",
    nextSequential: "Siguiente correlativo",
    estimated: "estimado",
    noteFoot: "El número no es definitivo: el primero que emita se lo lleva.",
    confirmEmit: "Confirmar y emitir factura",
    previewPdf: "Previsualizar PDF",
    sendQuote: "Enviar presupuesto",
    edit: "Editar factura",
    discard: "Descartar",
  },

  // Conceptos (líneas) del documento en curso: lo que se revisa ANTES de emitir.
  concepts: {
    title: "Conceptos del documento",
    item: "Artículo",
    qty: "Cant.",
    unitPrice: "P. Unit.",
    vat: "IVA",
    amount: "Importe",
    linesTotal: "Suma de conceptos",
    foot: "Así saldrá el desglose en la factura. El PDF lleva el detalle completo.",
    mismatch: "La suma de los conceptos ({lines}) no coincide con el total del documento ({total}). Revísalo antes de emitir.",
  },

  // Lo cobrado y lo que queda a deber. Mismas palabras y mismo orden que el
  // pie del PDF, para que leer la pantalla y leer la factura sea lo mismo.
  cobro: {
    total: "Total del documento",
    nothing: "Sin cobros registrados",
    due: "Pendiente de cobro",
    assumed: "No hay cobros anotados en esta reserva. El importe se da por cobrado a partir de la forma de pago marcada, y así saldrá también en el PDF. Si todavía no has cobrado, registra el cobro o cambia la forma de pago.",
  },

  actions: {
    sendWhatsapp: "Enviar WhatsApp",
    correct: "Corregir",
    void: "Anular",
    refresh: "Actualizar",
    retry: "Reintentar",
    editData: "Editar datos",
    delete: "Eliminar",
  },

  wa: {
    title: "Enviar factura por WhatsApp",
    desc: "Se enviará la factura <strong>{code}</strong> en PDF al huésped por WhatsApp.",
    issuedFallback: "emitida",
    checkPhone: "Se usará el teléfono del huésped asociado a la reserva",
    checkPdf: "El documento se enviará como PDF",
    send: "Enviar factura",
  },

  sendLink: {
    title: "Enviar link de facturación",
    desc: "Se enviará al huésped un <strong>enlace por WhatsApp</strong> para que confirme sus datos fiscales y descargue su factura.",
    checkNoInvoice: "No se emite ninguna factura todavía: el huésped solo recibe el enlace",
    button: "Enviar link",
  },

  retryModal: {
    title: "Reintentar emisión",
    desc: "Se volverá a intentar <strong>emitir esta factura</strong> con los datos actuales.",
    check1: "Se reenvía a la autoridad de facturación electrónica",
    check2: "Si tiene éxito se asigna el número fiscal definitivo",
  },

  voidModal: {
    doneTitle: "Factura anulada — Abono emitido",
    creditNoteIssued: "Factura rectificativa <strong>{code}</strong> emitida",
    chargesReleased: "Los cargos adicionales han sido liberados",
    clientCanRequest: "El cliente puede volver a solicitar la factura",
    doneHint: "Agrega o corrige los cargos pendientes y crea una nueva factura.",
    formTitle: "Anular factura / Emitir abono",
    formDesc: "Usa esta opción cuando necesitas <strong>añadir o cambiar servicios/importes</strong>. Se emitirá una <strong>factura rectificativa</strong> que anula la factura original, y podrás crear una nueva factura con los cargos correctos.",
    stepAnnul: "Se emite una factura rectificativa fiscal que anula {code}",
    stepFree: "Los cargos quedan libres para añadir o corregir",
    stepNewNumber: "Se crea una nueva factura con el número siguiente",
    notice: "Para corregir solo el NIF, nombre o dirección sin cambiar importes, usa <strong>Corregir datos</strong> en su lugar.",
    voiding: "Emitiendo abono…",
    confirm: "Anular y emitir abono",
  },

  edit: {
    titleDraft: "Editar factura",
    titleClient: "Editar datos del cliente",
    descDraft: "Los cambios se guardan al instante. Los datos fiscales se validan sin emitir.",
    descSent: "Al guardar se reintentará el envío automáticamente.",
    type: "Tipo",
    individual: "Particular",
    individualSub: "Persona física",
    company: "Empresa",
    companySub: "Persona jurídica",
    legalName: "Razón social",
    fullName: "Nombre completo",
    legalNamePlaceholder: "Razón social de la empresa",
    fullNamePlaceholder: "Nombre y apellidos",
    country: "País",
    countryPlaceholder: "Selecciona el país del huésped",
    taxRequiredOnEmit: "obligatorio al emitir",
    taxIdPlaceholderCompany: "NIF / CIF de la empresa",
    taxIdPlaceholderIndividual: "DNI / NIE · vacío = consumidor final",
    email: "Email",
    emailPlaceholder: "correo@ejemplo.com",
    phone: "Teléfono",
    phonePlaceholder: "+34 600 000 000",
    fiscalAddress: "Dirección fiscal",
    addressPlaceholder: "Calle y número",
    city: "Ciudad",
    region: "Región / Provincia",
    zip: "Código postal",
    saveChanges: "Guardar cambios",
    saveAndRetry: "Guardar y reintentar",
  },

  deleteModal: {
    title: "Eliminar factura",
    desc: "Se eliminará este intento de factura. El cliente podrá volver a solicitar la factura desde cero.",
    noticeIrreversible: "Esta acción no se puede deshacer.",
  },

  emit: {
    title: "Confirmar y emitir factura",
    subtitle: "Queda registrada oficialmente",
    desc: "Vas a emitir la factura de {name}.",
    stepNumberEstimate: "Se le asigna el número correlativo <b>{code}</b> — el primero que emita se lo lleva.",
    stepNumberFinal: "Se le asigna el número correlativo <b>definitivo</b> — el primero que emita se lo lleva.",
    stepPdf: "Se genera el PDF fiscal y se registra en Hacienda.",
    warn: "Una vez emitida <b>no se puede editar</b>. Si hay un error, habrá que <b>anularla y crear una factura nueva</b> (factura rectificativa).",
    confirm: "Confirmar y emitir",
  },

  newInvoice: {
    title: "Crear otra factura",
    subtitle: "Para esta misma reserva",
    desc: "Se abrirá un <strong>borrador nuevo</strong> para esta reserva.",
    step1: "Llevará <b>solo los cargos nuevos</b> que añadas — el alojamiento ya facturado no se repite.",
    step2: "Toma los datos del mismo cliente. El número se asigna al emitir.",
    createDraft: "Crear borrador",

    // Facturar toda la reserva o una sola habitación (reservas de varias).
    scopeTitle: "¿Cómo quieres facturar?",
    whole: "Toda la reserva",
    wholeHint: "Una sola factura con las {n} habitaciones.",
    perRoom: "Una habitación",
    perRoomHint: "Cada habitación, su factura. Para cuando cada huésped paga lo suyo.",
    pickRoom: "Elige la habitación",
    roomLodging: "Alojamiento",
    alreadyInvoiced: "ya facturada",
  },

  correction: {
    doneTitle: "Rectificativa emitida",
    createdOk: "Rectificativa <strong>{code}</strong> creada correctamente",
    originalKept: "La factura original queda como referencia fiscal (no se elimina)",
    pdfSoon: "El PDF se generará en breves momentos",
    title: "Corregir factura",
    infobox: "Se emitirá una <strong>factura rectificativa</strong> que sustituye fiscalmente a <strong>{code}</strong> e incluye los cargos actuales de la reserva. El número original no puede modificarse (es ley).",
    reasonLabel: "Motivo de la corrección",
    selectReason: "— Seleccionar motivo —",
    reasonTaxId: "NIF / CIF o Tax ID incorrecto",
    reasonName: "Nombre o razón social incorrecto",
    reasonAddress: "Dirección fiscal incorrecta",
    reasonEmail: "Email incorrecto",
    reasonGeneral: "Corrección general de datos fiscales",
    reasonOther: "Otro (escribir motivo)",
    customReasonPlaceholder: "Describe el motivo de la corrección…",
    recipientDivider: "Datos del destinatario — modifica solo lo que necesites corregir",
    nameOrLegalName: "Nombre / Razón social",
    taxIdFull: "NIF / CIF / Tax ID / Pasaporte",
    countryTwoLetters: "(2 letras)",
    paymentDivider: "Método de pago",
    paymentLabel: "Forma de pago",
    paymentUnspecified: "— Sin especificar —",
    paymentCash: "Efectivo",
    paymentCard: "Tarjeta de crédito / débito",
    paymentTransfer: "Transferencia bancaria",
    paymentStripe: "Stripe (online)",
    emitRectif: "Emitir rectificativa",
  },

  request: {
    typeCompany: "Empresa",
    typeIndividual: "Particular",
    type: "Tipo",
    legalName: "Razón social / Nombre",
    taxId: "NIF / CIF",
    address: "Dirección",
    postalCode: "C.P.",
    city: "Ciudad",
    state: "Provincia",
    country: "País",
    email: "Email",
  },

  toast: {
    linkSent: "Link de facturación enviado por WhatsApp al huésped.",
    alreadyIssued: "Esta reserva ya tiene factura emitida.",
    cantSendLink: "No se pudo enviar el link.",
    linkCopied: "Link copiado al portapapeles.",
    alreadyHasInvoice: "Esta reserva ya tiene factura.",
    cantGenerateLink: "No se pudo generar el link.",
    cantSendWhatsapp: "No se pudo enviar por WhatsApp.",
    invoiceSentWhatsapp: "Factura enviada por WhatsApp.",
    draftCreatedNewCharges: "Borrador creado con los cargos nuevos (sin repetir el alojamiento). Revísalo y emítelo.",
    draftCreated: "Borrador creado. Añade cargos y emítela cuando esté lista.",
    alreadyInProgress: "Esta reserva ya tiene una factura en curso.",
    cantCreateDraft: "No se pudo crear el borrador.",
    invoiceEmitted: "Factura emitida. Generando el número y el PDF…",
    cantEmit: "No se pudo emitir la factura.",
    cantPreview: "No se pudo generar la vista previa.",
    quoteSent: "Presupuesto enviado a {email}",
    cantSendQuote: "No se pudo enviar el presupuesto",
    cantSync: "No se pudo sincronizar el estado.",
    retrying: "Reintentando emisión…",
    cantRetry: "No se pudo reintentar.",
    cantVoid: "Error al anular la factura.",
    savedCheckFiscal: "Guardado. Revisa el documento fiscal.",
    dataUpdated: "Datos actualizados.",
    cantSaveData: "No se pudieron guardar los datos.",
    invoiceDeleted: "Factura eliminada.",
    cantDelete: "No se pudo eliminar.",
    cantEmitRectif: "Error al emitir la rectificativa.",
  },
};
